module.exports = __webpack_public_path__ + "static/media/Daniel Tish.d59fdd91.png";